import {
  type DashboardBackground,
  findGradientPreset,
  gradientCss,
  NEUTRAL_BACKGROUND_COLOR,
} from "@/lib/dashboard-home/background";
import type { CSSProperties } from "react";

/** Fond de repli pendant le chargement d'une image. */
const IMAGE_PLACEHOLDER_COLOR = "#2b2b2b";

function backgroundStyle(
  background: DashboardBackground,
  imageUrl: string | null,
): CSSProperties {
  switch (background.type) {
    case "color":
      return { backgroundColor: background.color };
    case "gradient":
      return {
        backgroundImage: gradientCss(findGradientPreset(background.gradientId)),
      };
    case "image":
      return imageUrl
        ? {
            backgroundColor: IMAGE_PLACEHOLDER_COLOR,
            backgroundImage: `url("${imageUrl}")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }
        : { backgroundColor: NEUTRAL_BACKGROUND_COLOR };
    default:
      return { backgroundColor: NEUTRAL_BACKGROUND_COLOR };
  }
}

/**
 * Fond de l'accueil, fixe et plein écran : le header (collé en haut) est donc
 * toujours posé sur la même bande, celle que mesure le calcul de contraste.
 */
export const HomeBackground = ({
  background,
  imageUrl,
}: {
  background: DashboardBackground;
  imageUrl: string | null;
}) => (
  <div
    className="fixed inset-0 z-0 transition-[background] duration-300"
    style={backgroundStyle(background, imageUrl)}
    aria-hidden
  />
);
